<app-frontend-navigation [autoSelect]="true" [subNavigation]="true"
                         [items]="navigationItems"
                         [showMobileLabels]="view.screenWidth > 330"
                         (onItemChanged)="onNavigationItemChanged($event)"/>

<div class="player-profile-tab-content pb-2_5">
  <app-loading [active]="isLoading" [center]="true"/>

  @if (playerProfile && !isLoading) {
    <div class="fadein animation-duration-100">
      @if (activeItem?.url === 'data') {
        <app-player-profile-account-data
          [playerProfile]="playerProfile"
          (onReload)="loadData(false)"
          (onUpdatePlayerProfileValue)="onUpdatePlayerProfileValue($event)"/>
      } @else if (activeItem?.url === 'personalData') {
        <app-player-profile-account-personal-data
          [playerProfile]="playerProfile"
          (onReload)="loadData(false)"
          (onUpdatePlayerProfileValue)="onUpdatePlayerProfileValue($event)"/>
      } @else if (activeItem?.url === 'payments') {
        <app-player-profile-account-payments
          [playerProfile]="playerProfile"/>
      } @else if (activeItem?.url === 'links') {
        <app-player-profile-account-links [playerProfile]="playerProfile"/>
      }
    </div>
  }
</div>
